import { Field, FileUploadStatus, FileUpload as ReactFileUpload } from '@panwds/react-ui';
import React, { useCallback, useEffect } from 'react';
import { get, useFormContext } from 'react-hook-form';
import { useIntl } from 'react-intl';
import { requiredMessage } from '../../messages.js';
/**
 * Renders an file upload connected to the form. All extra props will get passed to the file upload.
 */
export const FileUpload = (props) => {
    const { name, label, register: registerOptions = {}, description, tooltip, disabled, showLabel, requiredAsterisk, children, updateProgress, multiple = true, ...rest } = props;
    const intl = useIntl();
    const context = useFormContext();
    /* istanbul ignore next */
    if (context === null) {
        throw new Error('Attempted to render FileUpload outside of a Form context. Make sure your component is rendered inside <Form>.');
    }
    const { formState, register, setValue, watch, getValues } = context;
    registerOptions.required =
        registerOptions.required === false
            ? registerOptions.required
            : intl.formatMessage(requiredMessage, {
                label
            });
    const files = getValues(name) || [];
    useEffect(() => {
        if (updateProgress?.length) {
            setValue(name, [
                ...files.map((file) => {
                    const update = updateProgress.find((u) => u.id === file.id);
                    return update
                        ? {
                            ...file,
                            ...update
                        }
                        : file;
                })
            ], { shouldValidate: true, shouldDirty: true });
        }
    }, [updateProgress, setValue]);
    const handleDelete = useCallback((id) => {
        const updatedFiles = files.filter((file) => file.id !== id);
        setValue(name, updatedFiles, { shouldValidate: true, shouldDirty: true });
    }, [setValue, files]);
    const { ref, ...registerRest } = register(name, { ...registerOptions, ...(disabled ? { disabled } : {}) });
    return (React.createElement(Field, { label: label, optional: !registerOptions.required, connectLabel: false, control: React.createElement(ReactFileUpload, { ...rest, ...registerRest, title: "", onFiles: (newFiles) => {
                rest?.onFiles?.(newFiles);
                const prevFiles = watch(name) || [];
                setValue(name, [...newFiles, ...prevFiles], { shouldValidate: true, shouldDirty: true });
            }, appearance: formState.errors[name] ? 'error' : 'default', disabled: disabled || (!multiple && files.length > 0) }, files?.map((uFile) => {
            return (React.createElement(FileUploadStatus, { key: uFile.id, file: uFile.file, id: uFile.id, progress: uFile.progress, progressType: uFile.progressType, errorMessage: uFile.errorMessage, onDelete: handleDelete, showFileSize: false }));
        })), error: get(formState.errors, name)?.message, description: description, tooltip: tooltip, disabled: disabled, showLabel: showLabel, requiredAsterisk: requiredAsterisk }));
};
//# sourceMappingURL=FileUpload.js.map